import { FaFacebookF, FaInstagram, FaYoutube, FaCcVisa, FaCcMastercard, FaCcPaypal } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";
const Footer = () => {


  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter a valid email!");
      return;
    }

    try {
      await addDoc(collection(fireDB, "subscribers"), { email });
      setMessage("Subscribed successfully! 🎉");
      setEmail(""); // Clear input field
    } catch (error) {
      setMessage("Subscription failed. Try again!");
      console.error("Error:", error);
    }
  };

  return (
    <footer className="bg-green-700 text-white py-12">
      <div className="container mx-auto px-6">
        
        {/* Footer Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* About Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">About Us</h3>
            <ul className="space-y-2">
              <li><Link to="#" className="hover:text-black text-lg font-poppins">Careers</Link></li>
              <li><Link to="/faq" className="hover:text-black text-lg font-poppins">FAQs</Link></li>

            </ul>
          </div>

          {/* Support Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">Customer Support</h3>
            <ul className="space-y-2">
              <li><Link to="/ContactUs" className="hover:text-black text-lg font-poppins">Contact Us</Link></li>
              <li><Link to="/warranty" className="hover:text-black text-lg font-poppins">Warranty</Link></li>

            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/termsAndConditions" className="hover:text-black text-lg font-poppins">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-black text-lg font-poppins">Privacy Policy</Link></li>
              <li><Link to="/refund-policy" className="hover:text-black text-lg font-poppins">Refund Policy</Link></li>
            </ul>
          </div>

        {/*   <div>
      <h3 className="text-lg font-bold mb-4">Stay Updated</h3>
      <p className="text-black text-lg font-poppins text-sm mb-4">Subscribe to get updates on new arrivals, offers & discounts.</p>
      <form onSubmit={handleSubscribe} className="flex items-center border border-gray-600 rounded-md overflow-hidden">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-black text-white px-4 py-2 w-full focus:outline-none"
          required
        />
        <button type="submit" classNawhite px-4 py-2 text-white hover:bg-pink-600">Subscribe</button>
      </form>
      {message && <p className="text-sm mt-2 text-green-400">{message}</p>}
    </div>*/}

        </div>

        {/* Divider */}
        <div className="border-t border-black my-6"></div>

        {/* Footer Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          
          {/* Copyright */}
          <p className="text-white text-sm text-center">
            © 2025 Durapot. All Rights Reserved.
          </p>

        

          {/* Payment Methods */}
          {/* Social Icons */}
          <div className="flex space-x-6">
            <a href="#" className="text-white hover:text-pink-400 transition"><FaInstagram size={22} /></a>
            <a href="#" className="text-white hover:text-blue-400 transition"><FaFacebookF size={22} /></a>
            <a href="#" className="text-white hover:text-red-400 transition"><FaYoutube size={22} /></a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
